import { ListItem, Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { BillingInterval as BillingIntervalType } from 'types/generatedSchemaTypes';
import { ListItemWrapper, Row } from './styles';
import { useUiStore } from 'stores/uiStore';

const ArrowRight = () => <Icon name="Chevron_Right" />;

const BillingInterval = ({
  noBorder = false,
  pressable = true,
  backgroundColor = theme.colors.lightBg.green,
  pmcBillingFrequency,
}: {
  noBorder?: boolean;
  pressable?: boolean;
  backgroundColor?: string;
  pmcBillingFrequency?: BillingIntervalType;
}) => {
  const { selectedBillingFrequency } =
    usePermitStore((state) => state.selectedPermitBillingInterval) ?? {};
  const { t } = useTranslation();

  const selectedValue = pmcBillingFrequency ?? selectedBillingFrequency;

  const billingFrequencyText = selectedValue
    ? t(`longTermParking.billingFrequencies.${selectedValue}`)
    : t('longTermParking.select');

  const Title = useCallback(
    () => (
      <Meta color={theme.colors.gray300}>
        {t('longTermParking.billingFrequency')}
      </Meta>
    ),
    [t]
  );

  const RightContent = useCallback(
    () => (
      <Row>
        <Meta>{billingFrequencyText}</Meta>
        {!selectedValue && (
          <Icon name="Info-Filled-Black" color={theme.colors.boost.yellow} />
        )}
      </Row>
    ),
    [selectedValue, billingFrequencyText]
  );

  return (
    <ListItemWrapper noBorder={noBorder}>
      <ListItem
        accessible={true}
        accessibilityLabel={
          t('longTermParking.billingFrequency') + ': ' + billingFrequencyText
        }
        testID={'selected-billing-interval'}
        withBackground={backgroundColor}
        item={null}
        indexValue={0}
        titleComponent={Title}
        onPress={() =>
          pressable && useUiStore.getState().setSheetModal('billingIntervals')
        }
        arrowComponent={pressable ? ArrowRight : null}
        rightContentComponent={RightContent}
        rightContentAlignCenter
      />
    </ListItemWrapper>
  );
};

export default BillingInterval;
